module.exports = __webpack_public_path__ + "img/13.1ac801d5.png";